// extracted by mini-css-extract-plugin
export default {"logo":"YtsLogo_logo__RW9Cy"};